/** 对应 `src/assets/icons/partners/official/` 内的文件名（自各官网下载的 favicon / 公开标识）。 */
export interface PartnerLogo {
  officialFile: string;
}

export interface Partner {
  id: string;
  name: string;
  website: string;
  intro: string;
  logo: PartnerLogo;
}

/** 不包含上下游标签。 */
export const partners: Partner[] = [
  {
    id: "alicloud",
    name: "阿里云",
    website: "https://www.aliyun.com/",
    intro: "云端算力与安全能力合作，支撑企业业务上云与弹性扩展。",
    logo: { officialFile: "alicloud.ico" },
  },
  {
    id: "huaweicloud",
    name: "华为云",
    website: "https://www.huaweicloud.com/",
    intro: "云平台与政企场景方案协同，适配混合云与高可靠部署需求。",
    logo: { officialFile: "huaweicloud.ico" },
  },
  {
    id: "tencentcloud",
    name: "腾讯云",
    website: "https://cloud.tencent.com/",
    intro: "音视频、CDN 与云上中间件等资源协作，服务项目稳定运行。",
    logo: { officialFile: "tencentcloud.ico" },
  },
  {
    id: "jdcloud",
    name: "京东云",
    website: "https://www.jdcloud.com/",
    intro: "云基础设施与技术服务对接，适配电商与高并发应用场景。",
    logo: { officialFile: "jdcloud.ico" },
  },
  {
    id: "pinduoduo",
    name: "拼多多",
    website: "https://www.pinduoduo.com/",
    intro: "平台数字化与供应链管理相关系统建设与合作实践。",
    logo: { officialFile: "pinduoduo.png" },
  },
  {
    id: "zhubajie",
    name: "猪八戒网",
    website: "https://www.zbj.com/",
    intro: "服务撮合与政企采购等线上化能力对接的经验积累。",
    logo: { officialFile: "zhubajie.ico" },
  },
  {
    id: "oschina",
    name: "开源中国",
    website: "https://www.oschina.net/",
    intro: "技术社区曝光与开源生态联结，贴近开发者与项目落地。",
    logo: { officialFile: "oschina.ico" },
  },
  {
    id: "iflytek",
    name: "科大讯飞",
    website: "https://www.iflytek.com/",
    intro: "语音与认知智能相关能力与行业场景的方案融合。",
    logo: { officialFile: "iflytek.ico" },
  },
  {
    id: "aws",
    name: "亚马逊云 AWS",
    website: "https://aws.amazon.com/",
    intro: "全球区域与托管服务选型支持，适配出海与多地部署需求。",
    logo: { officialFile: "aws.ico" },
  },
  {
    id: "chinapost",
    name: "中国邮政",
    website: "https://www.chinapost.com.cn/",
    intro: "物流信息化与工单协同类系统在邮政场景中的落地与合作。",
    logo: { officialFile: "chinapost.ico" },
  },
  {
    id: "foxconn",
    name: "富士康",
    website: "https://www.honhai.com/",
    intro: "制造园区与大厂环境下的内部协同与管理类系统建设实践。",
    logo: { officialFile: "foxconn.ico" },
  },
  {
    id: "evergrande",
    name: "恒大物业",
    website: "https://www.chinahg-property.com/",
    intro: "物管工单、设施设备与多端协同的一体化平台建设经验。",
    logo: { officialFile: "evergrande.ico" },
  },
];
